export default "__VITE_ASSET__DnZHPeqy__"